import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'angular-community-job-detail',
  templateUrl: './job-detail.component.html',
  styleUrls: ['./job-detail.component.scss']
})
export class JobDetailComponent implements OnInit {
  jobDetailForm: UntypedFormGroup;

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
    this.setUpForm();
  }

  submitFormBtnClicked(): void {
    // this.listingsService.listings = [...this.listingsService.listings, this.jobDetailForm.value];
    this.router.navigate(['/jobs']);
  }

  setUpForm(): void {
    this.jobDetailForm = this.fb.group({
      jobTitle: ['Bounty Hunter', [Validators.required]],
      description: ['This is the way.', [Validators.required]],
      tags: ['tag1', []],
      contact: ['', [Validators.required]],
      skillLevel: ['', [Validators.required]],
      linkToLI: ['', []]
    });
  }

}
